import { HelperService } from '../services/helper.service'

export interface ISystemInfoModel {
  Company_Name?: string
  Plant_Name?: string
  Plant_Location_Lat?: string
  Plant_Location_Long?: string
  Company_Logo?: any
  Company_Logo_MimeType?: any
  Plant_Icon?: any
  Plant_Icon_MimeType?: any
  Plant_Ship_Heading?: number | null
}

export class SystemInfoModel implements ISystemInfoModel {
  Company_Name?: string
  Plant_Name?: string
  Plant_Location_Lat?: string
  Plant_Location_Long?: string
  Company_Logo?: any
  Company_Logo_MimeType?: any
  Plant_Icon?: any
  Plant_Icon_MimeType?: any
  Plant_Ship_Heading?: number | null

  public constructor(model?: ISystemInfoModel) {
    if (model) {
      Object.assign(this, model)
    }
  }

  public static fromJson(object: ISystemInfoModel): SystemInfoModel {
    const obj = new SystemInfoModel()
    obj.Company_Name = object.Company_Name ? object.Company_Name : null
    obj.Plant_Name = object.Plant_Name ? object.Plant_Name : null
    obj.Plant_Location_Lat = object.Plant_Location_Lat ? object.Plant_Location_Lat : null
    obj.Plant_Location_Long = object.Plant_Location_Long ? object.Plant_Location_Long : null
    obj.Company_Logo = object.Company_Logo ? object.Company_Logo : null
    obj.Company_Logo_MimeType = object.Company_Logo_MimeType ? object.Company_Logo_MimeType : null
    obj.Plant_Icon = object.Plant_Icon ? object.Plant_Icon : null
    obj.Plant_Icon_MimeType = object.Plant_Icon_MimeType ? object.Plant_Icon_MimeType : null
    obj.Plant_Ship_Heading = !HelperService.isNullOrUndefined(object.Plant_Ship_Heading)
      ? object.Plant_Ship_Heading
      : null
    return obj
  }

  public static fromJson4Cookie(object: ISystemInfoModel): SystemInfoModel {
    const obj = new SystemInfoModel()
    obj.Company_Name = object.Company_Name ? object.Company_Name : null
    obj.Plant_Name = object.Plant_Name ? object.Plant_Name : null
    obj.Plant_Icon = object.Plant_Icon ? object.Plant_Icon : null
    obj.Plant_Icon_MimeType = object.Plant_Icon_MimeType ? object.Plant_Icon_MimeType : null
    return obj
  }

  public getIconBase64URL(): string | null {
    if (this.Plant_Icon && this.Plant_Icon_MimeType) {
      return `data:${this.Plant_Icon_MimeType};utf8;base64, ${this.Plant_Icon}`
    }
    return null
  }

  public getLogoBase64URL(): string | null {
    if (this.Company_Logo && this.Company_Logo_MimeType) {
      return `data:${this.Company_Logo_MimeType};utf8;base64, ${this.Company_Logo}`
    }
    return null
  }
}
